import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtomValue } from "jotai";

import { createApiClient } from "@/config/createApiClient";
import { selectedClientServiceIdAtom } from "@/store";

import { FeatureFlagApi } from "../../config/apiClient";

const apiClient = createApiClient(FeatureFlagApi);

export const useFeatureFlags = () => {
  const selectedClientServiceIdAtomValue = useAtomValue(
    selectedClientServiceIdAtom
  );
  const queryClient = useQueryClient();

  const useGetFeatureFlags = () =>
    useQuery({
      queryKey: ["featureFlags", selectedClientServiceIdAtomValue],
      enabled: selectedClientServiceIdAtomValue > 0,
      queryFn: () =>
        apiClient.featureFlagsControllerGetFeatureFlags({
          clientServiceId: selectedClientServiceIdAtomValue,
        }),
    });

  const useCreateOrUpdateFeatureFlags = () =>
    useMutation({
      mutationKey: ["createOrUpdateFeatureFlags"],
      mutationFn: (
        body: Parameters<
          typeof apiClient.featureFlagsControllerCreateOrUpdateFeatureFlags
        >["0"]["featureFlagUpsertCommand"]
      ) =>
        apiClient.featureFlagsControllerCreateOrUpdateFeatureFlags({
          clientServiceId: selectedClientServiceIdAtomValue,
          featureFlagUpsertCommand: body,
        }),
      onSuccess: () =>
        Promise.all([
          queryClient.invalidateQueries({ queryKey: ["featureFlags"] }),
          queryClient.invalidateQueries({ queryKey: ["orders"] }),
          queryClient.invalidateQueries({ queryKey: ["order"] }),
          queryClient.invalidateQueries({ queryKey: ["orderItem"] }),
          queryClient.invalidateQueries({ queryKey: ["worklist"] }),
        ]),
    });

  return {
    useGetFeatureFlags,
    useCreateOrUpdateFeatureFlags,
  };
};
